import React from 'react';
import Text from 'Components/Text';

export default ({number, year, isPaid}) => {
  return (
    <section className='scene_section'>
      <header>Brand</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _width_pc_36 _margin_right_30'
        textClassName='text__text_primary'
        label='Brand Number'
        value={number}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary _width_pc_36 _margin_right_30'
        textClassName='text__text_primary'
        label='Year'
        value={year}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary _width_90'
        textClassName={`text__binary-status-text ${isPaid ? 'true' : 'false'}`}
        label='Payment Status'
        value={isPaid ? 'Paid' : 'Unpaid'}
      />
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/Application/Details/BrandTypeSection.jsx